import { createAction, props } from '@ngrx/store';
import { IAuthResponse } from '@app-root-interfaces';
import { TokenClaims } from '@scf-monorepo/interfaces';

export const checkToken = createAction('[Auth] Check token', props<{ authResponse: IAuthResponse }>());

export const login = createAction('[Auth] Login', props<{ authResponse: IAuthResponse }>());

export const loginSuccess = createAction(
    '[Auth] Login success',
    props<{ tokenUserData: TokenClaims; authResponse: IAuthResponse }>()
);

export const tokenExpired = createAction('[Auth] Token expired');
